/**
 * Renvoie vrai si l'argument passé est un objet
 * Stackoverflow magick (https://stackoverflow.com/a/16608045)
 *
 * @param {Object} obj  Valeur à tester
 */
const isPlainObject = obj => !!obj && obj.constructor === Object;

module.exports = isPlainObject;
